<section class="block-em" *ngIf="course">
    <header class="block-header course-header">
        <h5>
            <strong>{{course.Block}}</strong>
            <small>{{'bcContestApply_block' | translate}}</small>
            <a href="{{course.Url}}" target="_blank">
                {{course.SubjectCode}}, {{course.Subject}}
                <i class="fi fi-rs-angle-double-small-right"></i>
            </a>
        </h5>
        <aside class="align-self-start">
            <app-bc-contest-result [value]="course.Result"></app-bc-contest-result>
        </aside>
    </header>

    <app-alert level="danger" *ngIf="course.error">{{course.error}}</app-alert>

    <div class="row">
        <div class="col-sm-4 data-value">
            <label>{{'bcContestApply_lblLanguage' | translate}}</label>
            <div>
                {{course.Language}}
            </div>
        </div>

        <div class="col-sm-4 data-value">
            <label>{{'bcContestApply_lblCreditPoints' | translate}}</label>
            <div>
                {{course.CreditPoints | number:'1.0-2'}} ({{course.Ects | number:'1.0-2'}} ECTS)
                <span *ngIf="course.SemesterNumber" class="badge text-bg-primary">{{'bcContestApply_lblLongCourse' | translate}}</span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4 data-value">
            <label>{{'bcContestApply_lblExamType' | translate}}</label>
            <div>{{course.ExaminationType || ' - '}}</div>
        </div>

        <div class="col-sm-4 data-value">
            <label>{{'bcContestApply_lblManager' | translate}}</label>
            <div>{{course.Manager || ' - '}}</div>
        </div>

        <div class="col-sm-4 data-value">
            <label>{{'bcContestApply_lblDepartment' | translate}}</label>
            <div>{{course.Department}}</div>
        </div>
    </div>

    <hr class="block-sep mb-3" />

    <div class="form-field" *ngIf="course.groups.length == 1">
        <label class="form-label">{{'bcContestApply_lblPlaceTime' | translate}}</label>
        <div>
            <div class="group-row mb-1">
                <div class="group-row-check">
                    <app-checkbox [ngModel]="true" [disabled]="true"></app-checkbox>
                </div>

                <div class="group-row-data">
                    <span class="group-row-item">
                        <i class="fi fi-rs-marker"></i>
                        <span>{{course.Location}}</span>
                    </span>

                    <span class="group-row-item">
                        <i class="fi fi-rs-clock"></i>

                        <span *ngIf="course.HasDetailedPlanning">
                            <a href="#" (click)="$event.preventDefault(); openEvents(course, course.groups[0], 'calendar')">
                                {{getCourseDateTimeString(course, course.groups[0])}}
                            </a>
                        </span>

                        <span *ngIf="!course.HasDetailedPlanning && course.GroupDay && course.TimeFrom && course.TimeTo">
                            {{course.GroupDay}}, {{course.TimeFrom}} - {{course.TimeTo}}
                        </span>

                        <span *ngIf="!course.HasDetailedPlanning && (!course.GroupDay || !course.TimeFrom || !course.TimeTo)">
                            {{'bcContestApply_toBeSpecified' | translate}}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="form-field" *ngIf="course.groups.length > 1">
        <label class="form-label">{{'bcContestApply_lblPlaceTime' | translate}}</label>
        <div>
            <div class="group-row mb-1" *ngFor="let g of course.groups">
                <div class="group-row-check">
                    <app-checkbox [ngModel]="course.selectedGroupId == g.GroupId"
                                  [disabled]="course.ApplicationId"
                                  (stateChange)="onGroupChange($event, course, g)"
                                  name="group-{{course.Number}}-{{course.GroupId}}"></app-checkbox>
                </div>

                <div class="group-row-data">
                    <span class="group-row-item">
                        <i class="fi fi-rs-marker"></i>
                        <span>
                            <a *ngIf="course.HasDetailedPlanning && course.Info" href="#" (click)="$event.preventDefault(); openEvents(course, g, 'plan')">
                                {{'bcContestApply_showDescription' | translate}}
                            </a>
                            {{g.Location}}
                        </span>
                    </span>

                    <span class="group-row-item">
                        <i class="fi fi-rs-clock"></i>
                        <a href="#" (click)="$event.preventDefault(); openEvents(course, g, 'calendar')">
                            {{getCourseDateTimeString(course, g)}}
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <app-alert level="warning" *ngIf="warning">{{warning}}</app-alert>

    <div class="block-actions course-actions">
        <div class="course-status">
            <div class="text-sub">
                {{'bcContestApply_lblApplicantCount' | translate}}: {{course.ApplicationCount}}
            </div>
            <app-bc-contest-probability [value]="course.Probability"></app-bc-contest-probability>
        </div>

        <button *ngIf="!course.ApplicationId && !isReadOnly" type="button" class="btn btn-outline-primary" (click)="add(course)"
                [disabled]="disabled || (course.groups.length > 1 && !course.selectedGroupId)">
            {{'bcContestApply_btnAddApplication' | translate}}
        </button>

        <button *ngIf="course.ApplicationId && !isReadOnly" type="button" class="btn btn-secondary" (click)="remove(course)"
                [disabled]="disabled">
            {{'bcContestApply_btnRemoveApplication' | translate}}
        </button>
    </div>
</section>
